import React from "react";
import { FaHeart } from "react-icons/fa";
import "./Footer.scss";

const Footer = () => {
    return (
        <section className="footer">
            <div className="footer__details">
                <img
                    src="./images/forhad_icon.png"
                    alt="icon"
                    className="bgImg"
                />
                <p>
                    Thank You For Visit My Profile
                    <span>
                        <FaHeart />
                    </span>
                </p>
            </div>
        </section>
    );
};

export default Footer;
